// Module
var code = "<a class=\"reload\" data-bind=\"click: OnClick, tooltip: Tooltip\"> </a>";
// Exports
export default code;